import userShape from './user';

// eventually we'll be more precise in what props are acceptable on user vs integration,
// but for now they're the same
export default userShape;



// WEBPACK FOOTER //
// ./js/types/api/integration.js